import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {USERCOURSEPROGRESS} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";
import {UserFilterMixin} from "../FilterMixin";

export default {
    mixins: [DatatableHelperMixin,UserFilterMixin],
    data() {
        return {
            options: {
                name: this.$t('userCourseProgresses.title'),
                url: USERCOURSEPROGRESS,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('user'),
                        type: 'custom-html',
                        key: 'user',
                        isVisible: true,
                        modifier: (user) => {
                            return user ? user.full_name ? user.full_name : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('course'),
                        type: 'custom-html',
                        key: 'course',
                        isVisible: true,
                        modifier: (course) => {
                            return course ? course.title ? course.title : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: status => {
                            return `<span class="badge badge-pill badge-${status.class}">
                                ${status.translated_name}
                            </span>`
                        }
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value) ?? null;
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('status'),
                        type: "checkbox",
                        key: "status",
                        option: [],
                        listValueField: 'value'
                    },
                    {
                        title: this.$t('user'),
                        type: "multi-select-filter",
                        key: "users",
                        option: [],
                        listValueField: 'full_name',
                        permission: !!this.$can('view_users')
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-user-course-progress-modal',
                        modalId: 'user-course-progress-modal',
                        url: USERCOURSEPROGRESS,
                        name: 'edit',
                        modifier: row => this.$can('update_user_course_progress')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'user-course-progress-modal',
                        url: USERCOURSEPROGRESS,
                        name: 'delete',
                        modifier: row => this.$can('delete_user_course_progress')
                    }
                ],
            }
        }
    }
}
